export default [
  {
    fullName: 'Андрей Бибиков',
    jobTitle: 'Руководитель SaaS сервисов, <br> Т1 Cloud',
    photo: require('@/assets/speakers/Бибиков.png')
  }
]
